import React from 'react';
import { useTodos } from './hooks/useTodos';
import Header from './components/Header';
import AddTodo from './components/AddTodo';
import FilterBar from './components/FilterBar';
import TodoList from './components/TodoList';
import DataManager from './components/DataManager';

function App() {
  const {
    todos,
    filters,
    setFilters,
    addTodo,
    updateTodo,
    toggleTodo,
    deleteTodo,
    clearCompleted,
    clearAll,
    importTodos,
    getCategories,
    getStats
  } = useTodos();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Header />

        <AddTodo
          onAdd={addTodo}
          categories={getCategories()}
        />

        <DataManager
          todos={todos}
          onImportTodos={importTodos}
        />

        <FilterBar
          filters={filters}
          onFiltersChange={setFilters}
          categories={getCategories()}
          stats={getStats()}
          onClearCompleted={clearCompleted}
          onClearAll={clearAll}
        />

        <TodoList
          todos={todos}
          onToggle={toggleTodo}
          onUpdate={updateTodo}
          onDelete={deleteTodo}
        />
      </div>
    </div>
  );
}

export default App;
